<template>
  <div id="media">
    <div class="title">
      <div class="text">
        <p>DESPRE CASE STUDY</p>
      </div>
    </div>
    <div class="Container">
      <div class="potato"></div>
      <div class="content">
        <p>{{aboutCaseStudy.content}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import aboutCaseStudy from "@/assets/resources/aboutCaseStudy.js";

export default {
  data() {
    return {
      aboutCaseStudy,
    };
  },
};
</script>

<style scoped lang="scss">
#media {
  width: 100%;
  overflow: hidden;
  background-color: #0d2a4c;
  background-size: cover;
  background-position: center;
  position: relative;
  padding-top: 10vh;
}

.potato {
  float: right;
  position: relative;
  top: 5vh;
  background-image: url("../../assets/images/right svg.svg");
  background-size: cover;
  shape-outside: url("../../assets/images/right svg.svg");
  shape-margin: 5vw;
  width: 30vw;
  height: 0;
  padding: 0;
  padding-bottom: calc(100% * 3 / 6);
  z-index: 0;
}

@media only screen and (min-width: 2500px) {
  .potato {
    shape-margin: 7vw;
  }
}

.test-wrapper {
  margin-bottom: 10vh;
}

.title {
  position: relative;
  top: 35vh;
  position: relative;
  display: block;
  font-family: Acumin Variable Concept;
}

.text {
  display: block;
  margin-bottom: 0px;
  margin-left: 10.4vw;
  width: 70vw;
  height: 11.48vh;
  text-align: left;
  font-family: Acumin Variable Concept;
}

.text > p {
  font-weight: bold;
  font-family: Acumin Variable Concept;
  font-size: 6vh;
  letter-spacing: 0vh;
  color: #ffffff;
  margin-bottom: 0vh;
  font-family: Acumin Variable Concept;
}

.Container {
  //   margin-top: 0vh;
  //   width: 100%;
  padding-bottom: 14vh;
}

.content {
  width: 100%;
  padding-top: 40vh;
  width: 80vw;
  opacity: 1;
  text-align: left;
  // margin-left: 13.03vw;
}

.content > p {
  position: relative;
  margin-left: 10vw;
  color: white;
  font-size: 3.51vh;
  font-family: Acumin Variable Concept;
  line-height: 1.7;
  z-index: 10;
  display: block;
}

// MOBILE VIEW

@media only screen and (max-width: 1024px) {
  .title {
    position: absolute;
    top: 30%;
  }
  .text > p {
    font-size: 5.5vw;
  }
  .potato {
    top: 20vh;
  }
  .content > p {
    font-size: 4vw;
    margin-left: 0;
    width: 80vw;
    left: 10vw;
  }
}
</style>
